import React from 'react';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { CustomQuestion } from '../Question';
import Oxford from 'assets/livenicons/oxford.svg';
import Cambridge from 'assets/livenicons/cambridge.svg';
import Harvard from 'assets/livenicons/harvard.svg';
import { StickyContainer } from 'components/stickycontainer/StickyContainer';
import Spacer from 'components/spacer/Spacer';
import { useAppDispatch } from 'bootstrap/hooks';
import { appAnalytics } from 'analytics';
import { goToNextQuestion } from 'bootstrap/onboarding/actions';
import { SaveAnswer } from 'analytics/AllEvents';
import { useFeatures } from 'useFeatures';

import styles from './styles.module.scss';

type Props = QuestionComponentProps<CustomQuestion>;

export const LivenResearch: React.FC<Props> = ({ question }: Props) => {
  const dispatch = useAppDispatch();
  const features = useFeatures();

  const nextButtonHandler = () => {
    setTimeout(() => {
      appAnalytics.trackEvent(new SaveAnswer(question.id));
      dispatch(goToNextQuestion(features));
    }, 250);
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>
        Loóna was developed using scientific practices
      </h3>
      <p className={styles.description}>
        Your journey is based on decades of research
      </p>
      <div className={styles.imagesWrapper}>
        <img src={Harvard} alt="" />
        <img src={Oxford} alt="" />
        <img src={Cambridge} alt="" />
      </div>
      <Spacer />
      <StickyContainer className={styles.buttonContainer}>
        <button className={styles.button} onClick={nextButtonHandler}>
          Continue
        </button>
      </StickyContainer>
    </div>
  );
};
